import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ribbon from "./components/Ribbon";
import Services from "./components/Services";
import Projects from "./components/Projects";
import Process from "./components/Process";
import Advantages from "./components/Advantages";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    const scrollTo = (target) => {
        if (window.__lenis) {
            window.__lenis.scrollTo(target, { offset: -72 });
        } else {
            document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className="min-h-screen bg-ink text-white antialiased">
            <div className="noise" aria-hidden="true" />
            <Navbar onNavigate={scrollTo} />
            <main>
                <Hero onNavigate={scrollTo} />
                <Ribbon />
                <Services />
                <Projects />
                <Process />
                <Advantages />
                <Testimonials />
                <Contact />
            </main>
            <Footer onNavigate={scrollTo} />
            <Toaster position="bottom-right" theme="dark" />
        </div>
    );
}

export default App;
